var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSupportPrivacypolicy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#62EAA3",
    strokeWidth: 2.4,
    strokeLinejoin: "round",
    d: "M21.087 40.151h17.808"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4EC689",
    strokeWidth: 2.4,
    d: "M57.057 41.255V25.067M57.057 25.067v-6.232L47.38 9.2H16.2c-.55 0-1 .451-1 1v51.58c0 .55.45 1 1 1h19.928"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4EC689",
    strokeWidth: 2.4,
    strokeLinejoin: "round",
    d: "M47.38 9.2v9.348h9.677"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#62EAA3",
    strokeWidth: 2.4,
    strokeLinejoin: "round",
    d: "M21.529 18.822h17.808M21.529 25.932h23.936M21.529 33.042h23.936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.199 66.505c12.335-3.857 11.82-18.627 11.82-18.627l-11.797-4.975h-.005l-11.8 4.974s-.553 14.77 11.782 18.628z",
    stroke: "#4EC689",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.206 61.757c7.575-2.37 7.26-11.44 7.26-11.44L49.22 47.26h-.003l-7.246 3.055s-.34 9.07 7.235 11.44z",
    stroke: "#62EAA3",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSupportPrivacypolicy);
export default __webpack_public_path__ + "static/media/ic-support-privacypolicy.f0d8100ea3d76a405ffc5063f24ed533.svg";
export { ForwardRef as ReactComponent };